import React from 'react';

export class BreakSession extends React.Component {
    constructor(props) {
        super(props);

        this.handleDragStart = this.handleDragStart.bind(this);
    }

    handleDragStart(event) {
        const data = {source: 'breakSession', session: this.props.session};
        event.dataTransfer.setData("text/plain", JSON.stringify(data));
    }

    render() {
        const {session} = this.props;
        return (
            <div>
                <div className="panel panelbreak dragthis" draggable='true' onDragStart={this.handleDragStart}>
                    <div className="break">
                        <div className="panel-body">
                            <div className="breakname">{session.data.name}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
